import articles from './news.en.json';
import {localizeNewsTitle} from './translation';

export const newsPath = (path, english) => english ? `/en${path}` : path;
export function getNewsTranslation(news) {
    return news ? articles[news.preview] : undefined;
}
export function localizeNews(news, english) {
    if (!news || !english) return news;
    const translation = getNewsTranslation(news);
    return {...news, title: localizeNewsTitle(news, true), previewText: translation?.previewText || news.previewText,
        url: newsPath(news.url, true), originalTitle: news.title, untranslated: !translation};
}
